import 'react-table/react-table.css';
import * as React from 'react';
import { Grid as JrGrid } from './components';
//import Grid from './components'
export * from './memory';

export const Grid = (props: any) => {
  return <JrGrid {...props} />;
};
